// eslint-disable-next-line no-restricted-imports
import { useLocalStorage as useLocalStorageOriginal } from 'react-use';
import { Dispatch } from 'react';

// We wanna get rid of the annoying "undefined" that could be caused by unsetting the value from the local storage.
type UseLocalStorage = <T = unknown>(
    key: string,
    initialValue: T,
    options?:
        | {
              raw: true;
          }
        | {
              raw: false;
              serializer: (value: T) => string;
              deserializer: (value: string) => T;
          }
        | undefined,
) => [T, Dispatch<T>]; // Unfortunately `Dispatch<SetStateAction<T>>` is buggy, so we limit it to `Dispatch<T>`.

export const useLocalStorage: UseLocalStorage = useLocalStorageOriginal as any;
